import { Link } from "@tanstack/react-router"
import { featurePages } from "@/lib/feature-pages"
import { Logo } from "@/components/Logo"

export function PublicFooter() {
  return (
    <footer className="border-t border-border py-8 px-6">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Logo className="h-6 w-6 rounded-md" />
          <span className="text-sm font-bold">
            Chic<span className="text-primary">Travel</span>
          </span>
        </div>
        <p className="text-xs text-muted-foreground">
          © 2026 ChicTravel. All rights reserved.
        </p>
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-muted-foreground">
          <Link to="/" className="hover:text-foreground transition-colors">
            Home
          </Link>
          <Link to="/trips/explore" className="hover:text-foreground transition-colors">
            Explore
          </Link>
          <Link to="/blogs" className="hover:text-foreground transition-colors">
            Blog
          </Link>
          {featurePages.map((page) => (
            <Link
              key={page.to}
              to={page.to}
              className="hover:text-foreground transition-colors"
            >
              {page.label}
            </Link>
          ))}
          <Link to="/privacy" className="hover:text-foreground transition-colors">
            Privacy
          </Link>
          <Link to="/terms" className="hover:text-foreground transition-colors">
            Terms
          </Link>
          <Link to="/contact" className="hover:text-foreground transition-colors">
            Contact
          </Link>
        </div>
      </div>
    </footer>
  )
}
